export default __webpack_public_path__ + "static/gsr_harness_manifold-51ec3f7bdd42034e1ea1044769af236e.jpg";